import { Nullable } from 'chaika-frontend-types/frontend-cms';

import { EntryTypeBlockStatus, EntryTypeFieldType, EntryTypeStatus, EntryTypeType } from 'chaika-enums';

import { OptionType } from '@components/Select';
import { getTranslatesForAllLocales, translate } from '@chaika/i18n/helper';
import { getCommonStatusTranslation, getEntryTypeTypeTranslation } from '@utils/enumTranslation';
import type { AllKeyOf } from 'chaika-common-types';

export const enum ElementWidth {
    OnePerLine = 1,
    TwoPerLine = 6,
    ThreePerLine = 4,
    FourPerLine = 3,
    AnotherOnePerLine = 12,
}

export const enum BlockFieldsAlign {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}

export function getEntryTypeWithoutMedCaseTitles(): string[] {
    return [...getTranslatesForAllLocales('attachedDocument'), ...getTranslatesForAllLocales('patientFiles')];
}

export const getBlogAlignOptions = (): OptionType<Nullable<BlockFieldsAlign>>[] => [
    {
        value: null,
        label: translate('default'),
    },
    {
        value: BlockFieldsAlign.Left,
        label: translate('leftAligned'),
    },
    {
        value: BlockFieldsAlign.Center,
        label: translate('inTheCenter'),
    },
    {
        value: BlockFieldsAlign.Right,
        label: translate('rightAligned'),
    },
];

export const widthOptions: OptionType<Nullable<number>>[] = [
    {
        value: ElementWidth.OnePerLine,
        label: '1',
    },
    {
        value: ElementWidth.FourPerLine,
        label: '1/4',
    },
    {
        value: ElementWidth.ThreePerLine,
        label: '1/3',
    },
    {
        value: ElementWidth.TwoPerLine,
        label: '1/2',
    },
];

export const entryTypeStatusOptions = [
    {
        value: EntryTypeStatus.Active,
        label: getCommonStatusTranslation(EntryTypeStatus.Active),
    },
    {
        value: EntryTypeStatus.Draft,
        label: getCommonStatusTranslation(EntryTypeStatus.Draft),
    },
    {
        value: EntryTypeStatus.Archived,
        label: getCommonStatusTranslation(EntryTypeStatus.Archived),
    },
];

export const entryTypeTypeOptions = [
    {
        value: EntryTypeType.Consultation,
        label: getEntryTypeTypeTranslation(EntryTypeType.Consultation),
    },
    {
        value: EntryTypeType.Diagnostics,
        label: getEntryTypeTypeTranslation(EntryTypeType.Diagnostics),
    },
    {
        value: EntryTypeType.Manipulation,
        label: getEntryTypeTypeTranslation(EntryTypeType.Manipulation),
    },
    {
        value: EntryTypeType.UsDiagnostics,
        label: getEntryTypeTypeTranslation(EntryTypeType.UsDiagnostics),
    },
    {
        value: EntryTypeType.Tests,
        label: getEntryTypeTypeTranslation(EntryTypeType.Tests),
    },
];

export const entryTypeBlockStatusOptions = [
    {
        value: EntryTypeBlockStatus.Active,
        label: getCommonStatusTranslation(EntryTypeBlockStatus.Active),
    },
    {
        value: EntryTypeBlockStatus.Draft,
        label: getCommonStatusTranslation(EntryTypeBlockStatus.Draft),
    },
    {
        value: EntryTypeBlockStatus.Archived,
        label: getCommonStatusTranslation(EntryTypeBlockStatus.Archived),
    },
];

export enum EntryMedicalCaseElements {
    MedicalCasesSection = 'entryMedicalCases',
    OpenMedicalCasesBlock = 'openMedicalCases',
    MedicalCaseDiagnosesBlock = 'medicalCaseDiagnoses',
    MedicalCaseTreatmentPlanBlock = 'medicalCaseTreatmentPlan',
}

export const getEntryMedicalCaseElementsDic = (status: EntryMedicalCaseElements): string => {
    const StatusDic: AllKeyOf<EntryMedicalCaseElements> = {
        [EntryMedicalCaseElements.MedicalCasesSection]: translate('entryMedicalCases'),
        [EntryMedicalCaseElements.OpenMedicalCasesBlock]: translate('openMedicalCases'),
        [EntryMedicalCaseElements.MedicalCaseDiagnosesBlock]: translate('medicalCaseDiagnoses'),
        [EntryMedicalCaseElements.MedicalCaseTreatmentPlanBlock]: translate('medicalCaseTreatmentPlan'),
    };

    return StatusDic[status];
};

export const ALWAYS_SHOW_VALUE_ENTRY_FIELD: string[] = [
    // Поля стоматологической формулы
    'new_field_0.5598885422620512',
    'new_field_0.4497939784021696',
    'new_field_0.34393793816734686',
    'new_field_0.8558800045762887',
    'new_field_0.8726387441638863',
    'new_field_0.30073807108313133',
    'new_field_0.545072626919417',
    'new_field_0.36681492211676314',
];

export const ENTRY_FIELD_EXCEPTIONS: (EntryTypeFieldType | string)[] = [
    EntryTypeFieldType.EntryMedicalCases,
    EntryTypeFieldType.Vaccinations,
    ...ALWAYS_SHOW_VALUE_ENTRY_FIELD,
];
